import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path fill-rule="evenodd" d="M23.383 19h2.234l.316 1.576a1.29 1.29 0 0 0 1.13.63l1.82-.388L30 22.682l-1.117 1.189c-.238.388-.238.87 0 1.258L30 26.318l-1.117 1.864-1.82-.388a1.291 1.291 0 0 0-1.13.63L25.617 30h-2.234l-.316-1.576a1.291 1.291 0 0 0-1.13-.63l-1.82.388L19 26.318l1.117-1.189c.238-.388.238-.87 0-1.258L19 22.682l1.117-1.864 1.82.388c.467.005.901-.236 1.13-.63L23.383 19zm1.117 7.333a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="m18.003 15.989 1.555.315a14.66 14.66 0 0 1 2.442.802c-3.054.865-5.294 3.699-5.294 7.06 0 .634.08 1.248.229 1.834H5.555A1.566 1.566 0 0 1 4 24.425v-3.151c0-2.198 2.536-4.088 6.223-4.97 0 0 1.02-.229 1.556-.315a7.669 7.669 0 0 1-2.334-5.349V9.514c0-1.97 1.038-3.79 2.723-4.775a5.387 5.387 0 0 1 5.445 0 5.527 5.527 0 0 1 2.723 4.775v1.126a7.724 7.724 0 0 1-2.333 5.348z" clip-rule="evenodd"></path>';
export var UserSettingsSVG = function UserSettingsSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
UserSettingsSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(UserSettingsSVG);